module.exports = __webpack_public_path__ + "img/hero_portrait_witch-doctor_male.90abb899.png";